import * as env from 'src/utils/lib/env';

export const INFINITY_EXTENSION_STORE_URL = `https://chrome.google.com/webstore/detail/${env.getInfinityExtensionID()}`;

/**
 * Messages that Extension sends to the "embedded" Platform
 * @readonly
 * @enum {string}
 */
export const INCOMING_MESSAGE = {
  displayGenerationForm: 'displayGenerationForm',
  displayInsightsPanel: 'displayInsightsPanel',
  displaySuggestionsPanel: 'displaySuggestionsPanel',
  displayImportBrief: 'displayImportBrief',
  windowFocused: 'windowFocused',
  platformInfoCheck: 'platformInfoCheck',
  login: 'login',
  logout: 'logout',
  trackEvent: 'trackEvent',
  scoreText: 'scoreText',
  activateWorkspace: 'activateWorkspace',
};

/**
 * Messages that "embedded" Platform sends to the Extension
 * @readonly
 * @enum {string}
 */
export const OUTGOING_MESSAGE = {
  platformReady: 'platformReady',
  platformInfo: 'platformInfo',
  frameViewReady: 'frameViewReady',
  closeFrame: 'closeFrame',
  submitInstructions: 'submitInstructions',
  displayFullscreen: 'displayFullscreen',
  scoreTextResult: 'scoreTextResult',
  displaySuggestionInsights: 'displaySuggestionInsights',
  applySuggestion: 'applySuggestion',
  classifyTextResult: 'classifyTextResult',
  dictionaryBriefs: 'dictionaryBriefs',
  dictionaryResources: 'dictionaryResources',
  importedBrief: 'importedBrief',
};

/**
 * Messages that "external" Platform sends to the Extension
 * @readonly
 * @enum {string}
 */
export const EXTERNAL_MESSAGE = {
  login: 'login',
  logout: 'logout',
  activateWorkspace: 'activateWorkspace',
};

export const ERROR_CODE = {
  quotaEnded: 'quota_ended',
};
